import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import logo from '../assets/prathitha-logo.png';

const Footer: React.FC = () => {
  const navigate = useNavigate();

  return (
    <footer style={{
      background: 'linear-gradient(135deg, #0f0f2d 0%, #1a1a3e 50%, #0f0f2d 100%)',
      color: 'white',
      padding: '50px 5% 30px',
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* Decorative background elements */}
      <div style={{
        position: 'absolute',
        top: '-80px',
        right: '-100px',
        width: '300px',
        height: '300px',
        borderRadius: '50%',
        background: 'rgba(233, 30, 140, 0.08)',
        zIndex: 0,
        pointerEvents: 'none'
      }}></div>
      <div style={{
        position: 'absolute',
        bottom: '-50px',
        left: '-80px',
        width: '250px',
        height: '250px',
        borderRadius: '50%',
        background: 'rgba(59, 91, 219, 0.08)',
        zIndex: 0,
        pointerEvents: 'none'
      }}></div>
      <Row className="g-4 mb-4" style={{ position: 'relative', zIndex: 1 }}>
        <Col lg={4} md={6}>
          <div className="footer-about">
            <Link to="/" className="d-flex align-items-center gap-2 mb-2" style={{ textDecoration: 'none' }}>
              <img
                src={logo}
                alt="Prathitha Logo"
                style={{ 
                  width: 44, 
                  height: 44, 
                  objectFit: 'contain', 
                  borderRadius: 8, 
                  background: 'linear-gradient(135deg, #e91e8c 0%, #3b5bdb 100%)',
                  padding: 2,
                  boxShadow: '0 4px 12px rgba(233, 30, 140, 0.3)'
                }}
              />
              <div className="footer-logo-text">
                <span>Prathitha</span>
                <span>Digital Printers</span>
              </div>
            </Link>
            <p>Quality prints, on time, every time.</p>
            <div className="footer-social d-flex gap-2 mt-3">
              <a
                className="facebook-fab"
                href="https://www.facebook.com/profile.php?id=61586770149418"
                target="_blank"
                rel="noreferrer"
                title="Facebook"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '40px',
                  height: '40px',
                  borderRadius: '8px',
                  background: 'rgba(255, 255, 255, 0.1)',
                  color: 'white',
                  transition: 'all 0.3s ease',
                  cursor: 'pointer'
                }}
                onMouseEnter={(e) => {
                  (e.currentTarget as HTMLElement).style.background = 'linear-gradient(135deg, #e91e8c 0%, #3b5bdb 100%)';
                  (e.currentTarget as HTMLElement).style.transform = 'translateY(-4px)';
                }}
                onMouseLeave={(e) => {
                  (e.currentTarget as HTMLElement).style.background = 'rgba(255, 255, 255, 0.1)';
                  (e.currentTarget as HTMLElement).style.transform = 'translateY(0)';
                }}
              >
                <i className="fab fa-facebook-f"></i>
              </a>
              <a
                className="instagram-fab"
                href="https://www.instagram.com/prathithadigital/"
                target="_blank"
                rel="noreferrer"
                title="Instagram"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '40px',
                  height: '40px',
                  borderRadius: '8px',
                  background: 'rgba(255, 255, 255, 0.1)',
                  color: 'white',
                  transition: 'all 0.3s ease',
                  cursor: 'pointer'
                }}
                onMouseEnter={(e) => {
                  (e.currentTarget as HTMLElement).style.background = 'linear-gradient(135deg, #e91e8c 0%, #3b5bdb 100%)';
                  (e.currentTarget as HTMLElement).style.transform = 'translateY(-4px)';
                }}
                onMouseLeave={(e) => {
                  (e.currentTarget as HTMLElement).style.background = 'rgba(255, 255, 255, 0.1)';
                  (e.currentTarget as HTMLElement).style.transform = 'translateY(0)';
                }}
              >
                <i className="fab fa-instagram"></i>
              </a>
              <a
                href="https://wa.me/919150808130"
                target="_blank"
                rel="noreferrer"
                title="WhatsApp"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '40px',
                  height: '40px',
                  borderRadius: '8px',
                  background: 'rgba(255, 255, 255, 0.1)',
                  color: 'white',
                  transition: 'all 0.3s ease',
                  cursor: 'pointer'
                }}
                onMouseEnter={(e) => {
                  (e.currentTarget as HTMLElement).style.background = 'linear-gradient(135deg, #25d366 0%, #1fa855 100%)';
                  (e.currentTarget as HTMLElement).style.transform = 'translateY(-4px)';
                }}
                onMouseLeave={(e) => {
                  (e.currentTarget as HTMLElement).style.background = 'rgba(255, 255, 255, 0.1)';
                  (e.currentTarget as HTMLElement).style.transform = 'translateY(0)';
                }}
              >
                <i className="fab fa-whatsapp"></i>
              </a>
            </div>
          </div>
        </Col>
        <Col lg={2} md={6}>
          <div className="footer-col">
            <h4 style={{
              fontSize: '15px',
              fontWeight: 700,
              marginBottom: '18px',
              color: 'white',
              background: 'linear-gradient(90deg, #e91e8c 0%, #3b5bdb 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text'
            }}>Quick Links</h4>
            <ul className="list-unstyled">
              <li className="mb-2">
                <Link to="/" className="d-flex align-items-center gap-2" style={{ transition: 'all 0.2s ease' }} onMouseEnter={(e) => (e.currentTarget as HTMLElement).style.transform = 'translateX(4px)'} onMouseLeave={(e) => (e.currentTarget as HTMLElement).style.transform = 'translateX(0)'}>
                  <i className="fas fa-home" style={{ width: '16px', fontSize: '12px' }}></i>
                  <span>Home</span>
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/about" className="d-flex align-items-center gap-2" style={{ transition: 'all 0.2s ease' }} onMouseEnter={(e) => (e.currentTarget as HTMLElement).style.transform = 'translateX(4px)'} onMouseLeave={(e) => (e.currentTarget as HTMLElement).style.transform = 'translateX(0)'}>
                  <i className="fas fa-info-circle" style={{ width: '16px', fontSize: '12px' }}></i>
                  <span>About Us</span>
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/products" className="d-flex align-items-center gap-2" style={{ transition: 'all 0.2s ease' }} onMouseEnter={(e) => (e.currentTarget as HTMLElement).style.transform = 'translateX(4px)'} onMouseLeave={(e) => (e.currentTarget as HTMLElement).style.transform = 'translateX(0)'}>
                  <i className="fas fa-print" style={{ width: '16px', fontSize: '12px' }}></i>
                  <span>Products</span>
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/order" className="d-flex align-items-center gap-2" style={{ transition: 'all 0.2s ease' }} onMouseEnter={(e) => (e.currentTarget as HTMLElement).style.transform = 'translateX(4px)'} onMouseLeave={(e) => (e.currentTarget as HTMLElement).style.transform = 'translateX(0)'}>
                  <i className="fas fa-shopping-cart" style={{ width: '16px', fontSize: '12px' }}></i>
                  <span>Order Online</span>
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/portfolio" className="d-flex align-items-center gap-2" style={{ transition: 'all 0.2s ease' }} onMouseEnter={(e) => (e.currentTarget as HTMLElement).style.transform = 'translateX(4px)'} onMouseLeave={(e) => (e.currentTarget as HTMLElement).style.transform = 'translateX(0)'}>
                  <i className="fas fa-images" style={{ width: '16px', fontSize: '12px' }}></i>
                  <span>Portfolio</span>
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/faq" className="d-flex align-items-center gap-2" style={{ transition: 'all 0.2s ease' }} onMouseEnter={(e) => (e.currentTarget as HTMLElement).style.transform = 'translateX(4px)'} onMouseLeave={(e) => (e.currentTarget as HTMLElement).style.transform = 'translateX(0)'}>
                  <i className="fas fa-question-circle" style={{ width: '16px', fontSize: '12px' }}></i>
                  <span>FAQ / Help</span>
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/contact" className="d-flex align-items-center gap-2" style={{ transition: 'all 0.2s ease' }} onMouseEnter={(e) => (e.currentTarget as HTMLElement).style.transform = 'translateX(4px)'} onMouseLeave={(e) => (e.currentTarget as HTMLElement).style.transform = 'translateX(0)'}>
                  <i className="fas fa-envelope" style={{ width: '16px', fontSize: '12px' }}></i>
                  <span>Contact Us</span>
                </Link>
              </li>
            </ul>
          </div>
        </Col>
        <Col lg={3} md={6}>
          <div className="footer-col">
            <h4 style={{
              fontSize: '15px',
              fontWeight: 700,
              marginBottom: '18px',
              color: 'white',
              background: 'linear-gradient(90deg, #e91e8c 0%, #3b5bdb 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text'
            }}>Our Services</h4>
            <ul className="list-unstyled">
              {['Visiting Cards', 'Flyers & Brochures', 'Wedding Invitations', 'Flex Printing', 'Stickers & Labels'].map(s => (
                <li key={s} className="mb-2">
                  <a href="#" className="d-flex align-items-center gap-2" style={{ transition: 'all 0.2s ease' }} onMouseEnter={(e) => (e.currentTarget as HTMLElement).style.transform = 'translateX(4px)'} onMouseLeave={(e) => (e.currentTarget as HTMLElement).style.transform = 'translateX(0)'}>
                    <i className="fas fa-chevron-right" style={{ width: '12px', fontSize: '10px', color: 'var(--pink)' }}></i>
                    <span>{s}</span>
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </Col>
        <Col lg={3} md={6}>
          <div className="footer-col">
            <h4 style={{
              fontSize: '15px',
              fontWeight: 700,
              marginBottom: '18px',
              color: 'white',
              background: 'linear-gradient(90deg, #e91e8c 0%, #3b5bdb 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text'
            }}>Contact Info</h4>
            <div className="footer-contact-item" style={{
              display: 'flex',
              gap: '12px',
              marginBottom: '16px',
              fontSize: '13px',
              lineHeight: '1.5',
              color: 'rgba(255,255,255,0.7)'
            }}>
              <i className="fas fa-map-marker-alt" style={{ color: '#e91e8c', flexShrink: 0, marginTop: '2px' }}></i>
              <span>No.42, J.V.R Nagar Complex, N.S.R Road, Nehru Nagar, Kumaran Kundram, Chromepet, Tamil Nadu – 600044</span>
            </div>
            <div className="footer-contact-item" style={{
              display: 'flex',
              gap: '12px',
              marginBottom: '16px',
              fontSize: '13px',
              lineHeight: '1.5',
              color: 'rgba(255,255,255,0.7)'
            }}>
              <i className="fas fa-phone" style={{ color: '#3b5bdb', flexShrink: 0 }}></i>
              <span>+91 91508 08130</span>
            </div>
            <div className="footer-contact-item" style={{
              display: 'flex',
              gap: '12px',
              fontSize: '13px',
              lineHeight: '1.5',
              color: 'rgba(255,255,255,0.7)'
            }}>
              <i className="fas fa-envelope" style={{ color: '#10b981', flexShrink: 0 }}></i>
              <span>pdp@prathithadp.com</span>
            </div>
          </div>
        </Col>
      </Row>
      <div className="footer-bottom" style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingTop: '24px',
        marginTop: '24px',
        borderTop: '1px solid rgba(255,255,255,0.1)',
        position: 'relative',
        zIndex: 1
      }}>
        <span style={{ fontSize: '13px', color: 'rgba(255,255,255,0.6)' }}>Copyright© 2026 Prathitha Digital Printers. All Rights Reserved.</span>
        <button 
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          className="btn-scroll-top"
          style={{
            width: '40px',
            height: '40px',
            borderRadius: '8px',
            background: 'linear-gradient(135deg, #e91e8c 0%, #3b5bdb 100%)',
            color: 'white',
            border: 'none',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            boxShadow: '0 4px 12px rgba(233, 30, 140, 0.2)'
          }}
          onMouseEnter={(e) => {
            (e.currentTarget as HTMLElement).style.transform = 'translateY(-3px)';
            (e.currentTarget as HTMLElement).style.boxShadow = '0 6px 18px rgba(233, 30, 140, 0.3)';
          }}
          onMouseLeave={(e) => {
            (e.currentTarget as HTMLElement).style.transform = 'translateY(0)';
            (e.currentTarget as HTMLElement).style.boxShadow = '0 4px 12px rgba(233, 30, 140, 0.2)';
          }}
          title="Back to Top"
        >
          <i className="fas fa-chevron-up"></i>
        </button>
      </div>
    </footer>
  );
};

export default Footer;
